import { render, staticRenderFns } from "./LegalInformation.vue?vue&type=template&id=28ad7c18&scoped=true"
import script from "./LegalInformation.vue?vue&type=script&lang=js"
export * from "./LegalInformation.vue?vue&type=script&lang=js"
import style0 from "./LegalInformation.vue?vue&type=style&index=0&id=28ad7c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ad7c18",
  null
  
)

export default component.exports